import Box from '@mui/system/Box';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { HEADER_HEIGHT } from '../../data/constants';
import { POLICY_BREADCRUMBS_HEIGHT } from './Breadcrumbs';
import { POLICY_OVERVIEW_HEIGHT } from './PolicyOverview';

const PolicyInvoiceLayout = () => {
	return (
		<Box
			sx={{
				pt: 4,
				pb: 4,
				height: `calc(100vh - ${HEADER_HEIGHT}px - ${POLICY_BREADCRUMBS_HEIGHT}px - ${POLICY_OVERVIEW_HEIGHT}px)`,
			}}
		>
			<Outlet />
		</Box>
	);
};

export default PolicyInvoiceLayout;
